<template>
  <div>
    <!-- v-show="isLoading" -->
    <b-form @submit.prevent="submit" v-if="isLoading">
      <b-alert variant="primary" show v-if="!showUpload">{{
        $lang.alertAlgoritmDetailFrom
      }}</b-alert>
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.eventCaption"
            label-for="caption"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.eventCaption"
              :rules="$v.caption.$params"
            />
            <b-form-input
              id="caption"
              type="text"
              :autocomplete="$lang.eventCaption"
              v-model="$v.caption.$model"
              :state="$v.caption.$dirty ? !$v.caption.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="caption-feedback"
              >{{ $lang.error_required | replace($lang.caption) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <requiredComponent
            slot="label"
            :label="$lang.explanation"
            :rules="$v.description.$params"
          />
          <b-form-invalid-feedback id="name-feedback">
            {{
              $lang.error_required | replace($lang.explanation)
            }}</b-form-invalid-feedback
          >
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.event_type"
            label-for="event_type"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.event_type"
              :rules="$v.event_type_selected.$params"
            />
            <selectFind
              :options="event_type_options"
              v-model="$v.event_type_selected.$model"
              label="text"
              id="value"
              :isValid="
                $v.event_type_selected.$dirty
                  ? !$v.event_type_selected.$error
                  : null
              "
              :loading="event_type_Loading"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.event_type_selected.$error ? 'block' : 'none',
              }"
              id="event_type_selected_feedback"
            >
              {{ $lang.error_required | replace($lang.event_type_selected) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.time_checkpoint"
            label-for="time_checkpoint"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.time_checkpoint"
              :rules="$v.time_checkpoint_selected.$params"
            />
            <selectFind
              :options="time_checkpoint_options"
              v-model="$v.time_checkpoint_selected.$model"
              label="text"
              id="value"
              :isValid="
                $v.time_checkpoint_selected.$dirty
                  ? !$v.time_checkpoint_selected.$error
                  : null
              "
              :loading="time_checkpoint_Loading"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.time_checkpoint_selected.$error ? 'block' : 'none',
              }"
              id="time_checkpoint_selected_feedback"
            >
              {{ $lang.error_required | replace($lang.time_checkpoint) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.diff_time_checkpoint"
            label-for="diff_time_checkpoint"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="
                $lang.diff_time_checkpoint +
                ` ${
                  time_checkpoint_selected ? time_checkpoint_selected.text : ``
                }`
              "
              :rules="$v.diff_time_checkpoint.$params"
              :showInfo="true"
              :titleText="$lang.diff_time_checkpoint_tooltip"
            />

            <b-form-input
              id="diff_time_checkpoint"
              type="number"
              min="-999"
              max="999"
              :autocomplete="$lang.diff_time_checkpoint"
              v-model="$v.diff_time_checkpoint.$model"
              :state="
                $v.diff_time_checkpoint.$dirty
                  ? !$v.diff_time_checkpoint.$error
                  : null
              "
            >
            </b-form-input>

            <div
              class="invalid-feedback"
              v-if="!$v.diff_time_checkpoint.required"
            >
              {{ $lang.error_required | replace($lang.diff_time_checkpoint) }}
            </div>
            <div
              class="invalid-feedback"
              v-if="
                $v.diff_time_checkpoint.required &&
                (!$v.diff_time_checkpoint.minLengh ||
                  !$v.diff_time_checkpoint.maxLengh)
              "
            >
              {{
                $lang.error_Value
                  | replace($lang.diff_time_checkpoint, "-999", "999")
              }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.relatedRole"
            label-for="role"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.relatedRole"
              :rules="$v.role_selected.$params"
              :showInfo="true"
              :titleText="$lang.relatedRoleTooltip"
            />
            <selectFind
              :options="role_options"
              v-model="$v.role_selected.$model"
              label="text"
              id="value"
              :isValid="
                $v.role_selected.$dirty ? !$v.role_selected.$error : null
              "
              :loading="role_Loading"
            />
            <b-form-invalid-feedback
              :style="{ display: $v.role_selected.$error ? 'block' : 'none' }"
              id="role_selected_feedback"
            >
              {{ $lang.error_required | replace($lang.relatedRole) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="white-space mt-2">
          <b-form-checkbox
            id="checkbox-1"
            v-model="start_at_time"
            name="checkbox-1"
            :disabled="start_at_period == 1"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.start_at_time }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.start_at_time_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="4" class="white-space mt-2">
          <b-form-checkbox
            id="checkbox-2"
            v-model="start_at_period"
            name="checkbox-2"
            :disabled="start_at_time == 1"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.start_at_period }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.start_at_period_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="4" class="white-space mt-2">
          <b-form-checkbox
            id="checkbox-3"
            v-model="has_prerequisite"
            name="checkbox-3"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.prerequisites }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.prerequisites_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>

        <b-col cols="12" md="12" class="my-2">
          <requiredComponent
            slot="label"
            :label="$lang.event_text"
            :rules="$v.event_text.$params"
          />

          <b-form-invalid-feedback id="name-feedback">
            {{
              $lang.error_required | replace($lang.event_text)
            }}</b-form-invalid-feedback
          >
        </b-col>

        <b-col cols="12" md="12" class="mt-2 px-0">
          <uploadFile
            v-if="exerciseId && showUpload"
            :keyServies="`exercise`"
            :keyValue="exerciseId"
            :file_types="file_types"
          />
        </b-col>

        <b-col cols="12" md="12" class="float-right">
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="submit"
              v-if="permissionBtn"
              size="md"
              variant="success"
            >
              <i class="fa fa-check"></i>
              {{ $lang.submitButton }}
            </b-button>
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="cancel"
            >
              <i class="fa fa-ban"></i>
              {{ $lang.cancelButton }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import uploadFile from "@/components/base/uploadFile";
import {
  required,
  minLength,
  numeric,
  maxLength,
} from "vuelidate/lib/validators";
export default {
  validations: {
    caption: {
      required,
    },
    event_text: {
      required,
    },
    event_type_selected: {
      required,
    },
    diff_time_checkpoint: {
      required,
      numeric,
    },
    time_checkpoint_selected: {
      required,
    },
    role_selected: {},
    is_enable: {},
    description: {},
  },
  name: "algorithm_detail_form",
  components: {
    uploadFile,
  },
  props: {
    permissionBtn: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file_types: ["image", "office", "media", "other"],
      exerciseId: null,
      caption: null,
      event_type_selected: null,
      diff_time_checkpoint: null,
      role_selected: null,
      role_options: [],
      role_Loading: false,
      time_checkpoint_selected: null,
      event_text: null,
      event_type_options: [],
      time_checkpoint_options: [],
      event_type_Loading: false,
      time_checkpoint_Loading: false,
      is_enable_options: [],
      is_enable: null,
      has_prerequisite: 0,
      start_at_time: 0,
      start_at_period: 0,
      description: null,
    };
  },
  methods: {
    async getEventType() {
      try {
        const response = await this.$httpService.get(
          this.$config.api_url +
            this.$config.kanoon.enum_exercise_algorithm_detail_event_type
        );
        let { data } = response.data;
        this.event_type_options = data.map((x) => {
          return {
            text: x.enum_caption,
            value: x.enum_id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      }
    },
    async getRole() {
      try {
        this.role_Loading = true;
        const response = await this.$httpService.get(
          this.$config.api_url +
            this.$config.kanoon.enum_type.replace("{type}", "executive_role")
        );
        let { data } = response.data;
        this.role_options = data.map((x) => {
          return {
            text: x.enum_caption,
            value: x.enum_id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.role_Loading = false;
      }
    },
    async getTimeCheckpoint() {
      try {
        const response = await this.$httpService.get(
          this.$config.api_url +
            this.$config.resources
              .enum_exercise_algorithm_detail_time_checkpoint
        );
        let { data } = response.data;
        this.time_checkpoint_options = data.map((x) => {
          return {
            text: x.enum_caption,
            value: x.enum_id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      }
    },
    cancel() {
      this.$emit("cancel", false);
      this.$emit("modal-close", false);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        caption: this.caption,
        executive_role_id: this.role_selected && this.role_selected.value,
        event_type_id:
          this.event_type_selected && parseInt(this.event_type_selected.value),
        diff_time_checkpoint: parseInt(this.diff_time_checkpoint),
        time_checkpoint:
          this.time_checkpoint_selected && this.time_checkpoint_selected.value,
        event_text: this.event_text,
        is_enable: this.is_enable,
        has_prerequisite: this.has_prerequisite,
        start_at_time: parseInt(this.start_at_time),
        start_at_period: parseInt(this.start_at_period),
        description: this.description,
      };
      this.$emit("submit", payload);
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length > 0) {
        this.caption = this.item.caption;
        this.description = this.item.description;
        this.has_prerequisite = this.item.has_prerequisite;
        this.start_at_time = this.item.start_at_time;
        this.start_at_period = this.item.start_at_period;
        this.diff_time_checkpoint = this.item.diff_time_checkpoint;
        this.event_text = this.item.event_text;
        if (this.item.role) {
          this.role_selected = this.role_options.find(
            (x) => x.value == this.item.role.code
          );
        }
        if (this.item.time_checkpoint) {
          this.time_checkpoint_selected = this.time_checkpoint_options.find(
            (x) => x.value == this.item.time_checkpoint.id
          );
        }
        if (this.item.event_type) {
          this.event_type_selected = this.event_type_options.find(
            (x) => x.value == this.item.event_type.id
          );
        }
        if (this.item.executive_role) {
          this.role_selected = this.role_options.find(
            (x) => x.value == this.item.executive_role.id
          );
        }
      }
    },
  },
  async created() {
    if (this.item) this.exerciseId = this.item.id.toString();
    // this.getValue()
    await this.getRole(), await this.getEventType();
    await this.getTimeCheckpoint();
    this.fetchData();
  },
};
</script>
<style lang="scss">
.white-space {
  white-space: nowrap;
}
</style>
